module.exports = __webpack_public_path__ + "static/media/pasta-6263653_1280.74127c37.jpg";